import React from "react"
import Utils from "../utils/node.utils"
import { StaticQuery, graphql } from "gatsby"
import StaticPage from "../components/StaticPage/StaticPage"
import {
  createOverlay,
  createContentList,
} from "../contentfunctions/shipping.js"

import Carousel1 from "../images/shipping/shipping-policy-min.jpeg"

const ShippingPage = ({ location }) => {
  Utils.NavigateToBrowserLanguage("en", "/shipping", location.state)
  return (
    <StaticQuery
      query={pageQuery}
      render={data => {
        const commonContentMap = Utils.ContentListToMap(
          data.commonContent.item.content
        )
        const contentMap = Utils.ContentListToMap(
          data.shippingContent.item.content
        )
        const img = {
          src: Carousel1,
          altText: contentMap.seo_title.value,
          caption: contentMap.seo_description.value,
        }
        return (
          <StaticPage
            title={contentMap.seo_title.value}
            description={contentMap.seo_description.value}
            img={img}
            originPage="shipping"
            location={location}
            contentMap={contentMap}
            commonContentMap={commonContentMap}
            breadCrumbs={["menu_home", "menu_shipping"]}
            createContentFun={createContentList}
            createOverlayFun={createOverlay}
            keywords={Utils.GetKeywordsFromTags(data.shippingContent.item.tags)}
          />
        )
      }}
    />
  )
}

export default ShippingPage

const pageQuery = graphql`
  {
    shippingContent: shippingContentEngb {
      item {
        key
        tags {
          content {
            key
            value
          }
        }
        content {
          key
          value
        }
      }
    }

    commonContent: commonContentEngb {
      item {
        key
        content {
          key
          value
        }
      }
    }
  }
`
